import Component from './RowLabel.component';

export default Component;
